export default {
    methods: {
        InitShopCart() {
            this.$cookie.get("shopcart") == null ? this.$cookie.set('shopcart', "") : ""
            this.$store.commit("SetShopCart", this.GetShopCart())
        },
        GetShopCart() {
            if (this.$cookie.get("shopcart") == null || this.$cookie.get("shopcart").length <= 0) {
                return []
            } else {
                let string = this.$cookie.get("shopcart")
                let products = []
                let shopcart = string.split("p")
                shopcart.forEach(item => {
                    let product_id = item.split("s")[0]
                    let product_option_combine = item.split("s")[1]
                    let product_amount = item.split("s")[2]
                    products.push({
                        product_id: product_id,
                        product_option_combine: product_option_combine,
                        product_amount: product_amount
                    })
                })
                return products
            }
        },
        SetShopCart(items) {
            let shopcart_string = ""
            items.forEach((item, item_index) => {
                let string = item.product_id + "s"
                string += item.product_option_combine + "s"
                string += item.product_amount
                if (item_index != items.length - 1) {
                    string += "p"
                }
                shopcart_string += string
            })
            this.$cookie.set("shopcart", shopcart_string)
            this.$store.commit("SetShopCart", this.GetShopCart())
        },
        async AddToCart(product, option_combine) {
            this.GA_AddToCart(product.name, product.option_combine.filter(item => item.combine_id == option_combine)[0].option_text_group, product.option_combine.filter(item => item.combine_id == option_combine)[0].price, 1)
            this.$store.commit("SetShopCartMessage", 1)
            let shopcart = this.GetShopCart()
            let ifExist = -1
            shopcart.forEach((item, item_index) => {
                item.product_id == product.product_id && item.product_option_combine == option_combine ? ifExist = item_index : ""
            })
            if (ifExist != -1) {
                shopcart[ifExist].product_amount = parseInt(shopcart[ifExist].product_amount) + 1
            } else {
                shopcart.push({
                    product_id: product.product_id,
                    product_option_combine: option_combine,
                    product_amount: 1
                })
            }
            this.SetShopCart(shopcart)
        },
        async DeleteFromCart(product_index) {
            let shopcart = this.GetShopCart()
            shopcart.splice(product_index, 1)
            this.SetShopCart(shopcart)
        },
        async ChangeCartAmount(product_index, amount) {
            let shopcart = this.GetShopCart()
            shopcart[product_index].product_amount = amount
            this.SetShopCart(shopcart)
        }
    }
}